class BundleSelectors extends HTMLElement {
    constructor() {
      super();
      this.addToCartBtn = document.getElementById("AddToCart");
      this.data = JSON.parse(this.querySelector('#bundle-data').innerHTML);
      this.data.product_handles = [
        ...this.data.product_handles.map(product_handle => product_handle)
      ].flat()
      this.data.skus = this.data.skus.map(a => a == "" ? [] : a.split("|"))
      this.init()
      this.addEventListeners.bind(this)
      this.addBundleProperty.bind(this)
    }
  
    addEventListeners() {
      var self = this
      this.querySelectorAll("input").forEach(el => {
        el.addEventListener('change', function(event) {
          self.setInitialState()
        })
      })
    }

    fetchBundleProducts(handle) {
      return fetch(`/products/${handle}?view=data`)
    }
  
    init() {
      this.addToCartBtn.classList.add("hidden");
      var self = this
      const allHandles = this.data.product_handles.map(ph => ph.split("|")).flat().filter(val => val !== "");
      Promise.all(allHandles.map(this.fetchBundleProducts)).then(responses => {
        responses = responses.filter((r) => r.status == 200);
        console.log(responses);
        return Promise.all(responses.map(res => res.text()))
      }).then(texts => {
        try {
          self.data.products = texts.map(t => JSON.parse(t)).flat();
          self.buildHtml()
        } catch (e) {
          console.log('%c An error occured, a product is not found!', 'color: red');
          console.error(e);
          self.hideBundleSelector();
        }
      })
    }
  
    buildHtml() {
      this.buildSelectHeaders()
      this.buildSelectElements()
      this.addEventListeners()
      this.setInitialState()

      window.bundleProduct(); //dropdown listeners product-bundle.js

      this.addToCartBtn.classList.remove("hidden");
    }
  
    addBundleProperty(ids) {
      console.log(`%c Bundle variants selected! ${ids.join(",")}`, 'color: green');
      const forms = this.closest('section').querySelectorAll('form[action="/cart/add"]')
      if(ids.length == 0) {
        forms.forEach(el => {
          const addToCartBtn = el.querySelector('[name="add"]')
          if (!addToCartBtn) return;
          addToCartBtn.innerHTML = "Sold Out"
          addToCartBtn.disabled = true
        })
        return
      }
      forms.forEach(el => {
        const selector = `input[type="hidden"][name="properties[_bundle_ids]"]`
        const inputExists = el.querySelectorAll(selector);
        const idsEncoded = btoa(unescape(encodeURIComponent(ids.join(","))))
        if(inputExists.length) {
          inputExists[0].value = idsEncoded
        } else {
          var input = document.createElement('input')
          input.type = "hidden"
          input.name = "properties[_bundle_ids]"
          input.value = idsEncoded
          el.appendChild(input)
        }
        for(let i = 0; i < this.data.titles.length; i++) {
          let displayIndex = i+1;
          let inputRadio = this.querySelector(`#output-container [data-item-index="${i}"] input:checked`);
          const selectedProductTitle = inputRadio.dataset.bundleItemTitle;
          const selectedVariantTitle = inputRadio.dataset.bundleVariantTitle;
          const propSelector = `input[type="hidden"][name="properties[Item ${[displayIndex]}"]`
          const inputExists = el.querySelectorAll(propSelector);
          if(inputExists.length) {
            inputExists[0].value = `${selectedProductTitle}: ${selectedVariantTitle}`
          } else {
            var input = document.createElement('input')
            input.type = "hidden"
            input.name = `properties[Item ${[displayIndex]}]`
            input.value = `${selectedProductTitle}: ${selectedVariantTitle}`
            el.appendChild(input)
          }
        }
      })
    }
    
  
    setInitialState() {
      var ids = []
      this.querySelectorAll('input').forEach(el => {
        if(el.checked) {
          ids.push(el.value)
        }
      })
      this.addBundleProperty(ids)
    }
  
    buildSelectHeaders() {
      for(let i = 0; i < this.data.titles.length; i++) {

        const popupLabel = this.data.popup_button_label ? this.data.popup_button_label[i] : null;
        const popupId = this.data.popup_id ? this.data.popup_id[i] : null;

        let popupButton = ``;
        if (popupLabel && popupId) {
          popupButton = `
            <div class="modal-opener">
              <modal-opener class="product-popup-modal__opener no-js-hidden quick-add-hidden" data-modal="#${popupId}">
                <button id="${popupId}--${i}" class="product-popup-modal__button link" type="button" aria-haspopup="dialog">${popupLabel}</button>
              </modal-opener>
            </div>
          `;
        }

        const html = `
            <div class="bundle-selector__container bundle-product__title" data-item-index="${i}">
                <div class="title">${this.data.titles[i]}</div>
                ${popupButton}
            </div>
            <div class="bundle-product bundle-product__options product-form__item" data-item-index="${i}" id="bundle-product-wrap-${i}">
                <div class="radio-button-wrapper">
                    <button class="select-button" data-drawer-button>
                      <span class="visually-hidden">Select</span>
                    </button>
                    <fieldset data-radio-buttons data-for-id="bundle-product-wrap-${i}">
                    <legend class="visually-hidden">Product options</legend>
                      <div class="drawer-header">
                        <button class="cart-drawer__close drawer__close" type="button" aria-label="Close">
                          <svg width="18px" class="icon-close-humb" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" viewBox="0 0 18 17">
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                          </svg>
                        </button>
                        <div class="line_title"><span>${this.data.titles[i]}</span></div>
                      </div>
                    </fieldset>
                </div>
            </div>        
        `;

        $("#output-container").append(html);
      }
    }
  
    buildSelectElements() {
      for(let i = 0; i < this.data.product_handles.length; i++) {
        let first = true;
        const product_handles = this.data.product_handles[i].split("|")

        const isFree = this.data.isFree ? this.data.isFree[i]: false;
        const isFreeHtml = `${isFree?"<div class='is-free-badge'>Free</div>":""}`

        let optgroupOptions = product_handles.map(handle => {
          let products = this.data.products.filter(p => p.handle.indexOf(handle)  > -1).sort((a,b) => a.id > b.id ? 1 : -1)

          //we remove duplicated products based on handle. In case a bundle has two times same product.
          let uniqueHandles = new Set();
          products = products.filter(function(item) {
            if (uniqueHandles.has(item.handle)) {
              return false;
            } else {
              uniqueHandles.add(item.handle);
              return true;
            }
          });

          if(products.length) {
            let productTitle = products[0].title.split(" - ")[0];
            let firstVariantHtml = ``;
            for (const item in products){
              const currentItem = products[item];
              let firstItemFound = false;
              if(currentItem.available){

                //sort by SKUS
                let currentItemVariants = currentItem.variants;
                let SKUs = this.data.skus[i];
                if (SKUs.length > 0 ) {
                  currentItemVariants = currentItem.variants
                  .filter(curr => SKUs.includes(curr.sku))
                  .sort((a, b) => {
                    const aIndex = SKUs.indexOf(a.sku);
                    const bIndex = SKUs.indexOf(b.sku);
                    if (aIndex < bIndex) return -1;
                    if (aIndex > bIndex) return 1;
                    return 0;
                  });
                }

                for (const currentItemVariant of currentItemVariants) {
                  if (!currentItemVariant.available) {
                    continue;
                  };
                  firstItemFound = true;
                  const displayImg = currentItemVariant.featured_image ? currentItemVariant.featured_image.src : currentItem.featured_image;
                  firstVariantHtml = `<img src="${displayImg}" loading="lazy" alt="${productTitle}" width="80" height="80.0" class="">
                      <div>${currentItem.title} - ${currentItemVariant.title}</div>
                      ${isFreeHtml}
                  `;
                  break;
                }
                if (firstItemFound) break;
              }
            }

            const optgroupVariantsHtml = products.map(p => { 

              //sort variants by sku first
              let variants = p.variants;
              let SKUs = this.data.skus[i];
              if (SKUs.length > 0 ) {
                variants = variants
                .filter(curr => SKUs.includes(curr.sku))
                .sort((a, b) => {
                  const aIndex = SKUs.indexOf(a.sku);
                  const bIndex = SKUs.indexOf(b.sku);
                  if (aIndex < bIndex) return -1;
                  if (aIndex > bIndex) return 1;
                  return 0;
                });
              }
              
              return {
                label: p.title,
                html: variants.sort(function(a, b) {
                  if (a.available === b.available) {
                    return 0;
                  }
                  return a.available ? -1 : 1;
                }).map((variant) => {
                  if(this.data.skus[i].length > 0 && this.data.skus[i].indexOf(variant.sku) == -1) return "";
                  const displayImg = variant.featured_image ? variant.featured_image.src : p.featured_image;
                  let htmlReturn = `
                    <div class="radio-button-container" data-id="31308907285838-426" radio-button-container="" data-disabled="${!variant.available}">
                        <input ${!variant.available?"disabled":''} type="radio" name="product-bundle--${i}" id="${variant.id}-${i}" value="${variant.id}" data-bundle-variant-title="${variant.title}" data-bundle-item-title="${p.title}" data-product-id="${p.id}" ${first && variant.available ? 'checked' : ''}>
                        <label for="${variant.id}-${i}"> 
                            <img src="${displayImg}" loading="lazy" alt="${p.title}" width="80" height="80.0" class="">
                            <div data-title-complete="${p.title} - ${variant.title}">${variant.title}</div>
                            ${isFreeHtml}
                        </label>
                    </div>
                  `;
                  if (variant.available) {
                    first = false;
                  }
                  return htmlReturn;
                })
              }
            });
              
            return {label: productTitle, html: optgroupVariantsHtml, firstVariantHtml:firstVariantHtml}
          }
          return null
        })

        optgroupOptions = optgroupOptions.filter((opt) =>opt != null);
        optgroupOptions.sort((a, b) => {
          if (!a.firstVariantHtml) return 1;
          if (!b.firstVariantHtml) return -1;
          return 0;
        });

        const atLeastOneVariantAvailable = optgroupOptions.filter((el) => el.firstVariantHtml).length > 0;
        if (!atLeastOneVariantAvailable) {
          this.hideBundleSelector();
          return;
        }

        const selectElements = optgroupOptions.filter(og => og).map(g => {
          if (!g) return "";

          const label = `<div class="select-optground-label">${g.label}</div>`
                    
          return label + g.html.map((innerHtml) => {
            return innerHtml.html.join("")
          }).join("");
        })


        if (!optgroupOptions || optgroupOptions.length == 0 || !optgroupOptions[0]) return;

        $(`#output-container [data-item-index="${i}"] [data-drawer-button]`).append(optgroupOptions[0].firstVariantHtml);
        $(`#output-container [data-item-index="${i}"] [data-radio-buttons]`).append(selectElements.join(""));
      }
    }

    hideBundleSelector() {
      document.querySelector("bundle-selectors #output-container").style = "display:none";
      document.querySelector("bundle-selectors #output-container").setAttribute('aria-hidden', 'true');

      if (document.querySelector("#disable-msg-bundle")) return;

      let div = document.createElement("strong");
      div.id = "disable-msg-bundle";
      div.innerHTML = `Sorry, this bundle is currently unavailable due to 1 or more items being out of stock. <a href="/collections/bundle-save">Shop other bundles here</a>.`;

      document.querySelector("bundle-selectors").append(div);

      const addToCartBtn = document.querySelector("#AddToCart button");
      addToCartBtn.classList.add("bundle-disabled");
      addToCartBtn.setAttribute("disabled", true);
      addToCartBtn.textContent = "Unavailable";

      const stickyAdd = document.querySelector("sticky-product-add");
      if (stickyAdd) {
        stickyAdd.classList.add("hidden");
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', (event) => {
    customElements.define('bundle-selectors', BundleSelectors);
  });
